import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.categoria.fields.id'),
  },
  {
    name: 'nombre',
    label: i18n('entities.categoria.fields.nombre'),
  },
  {
    name: 'extracto',
    label: i18n('entities.categoria.fields.extracto'),
  },
  {
    name: 'descripcion',
    label: i18n('entities.categoria.fields.descripcion'),
  },
  {
    name: 'avatar',
    label: i18n('entities.categoria.fields.avatar'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'portada',
    label: i18n('entities.categoria.fields.portada'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'incluirEstadisticas',
    label: i18n('entities.categoria.fields.incluirEstadisticas'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.categoria.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.categoria.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
